import { Card, Typography } from 'antd';
import { Statistic } from 'antd';
import React, { FC } from 'react';
import '../style.scss';
import PageTopWrapper from './page-top-wrapper';

interface IProps {
    dataReport: any;
}

const ReportStatus: FC<IProps> = ({ dataReport }) => {
    const gridStyle: any = {
        width: `${100 / 6}%`,
        textAlign: 'center',
        padding: '10px',
        height: '87px',
    };
    return (
        <div className="report-content">
            <PageTopWrapper leftContent={<Typography.Title level={5}>Báo cáo chung</Typography.Title>} />
            <Card>
                <Card.Grid style={gridStyle}>
                    {' '}
                    <Statistic
                        title="Tiền phòng"
                        value={dataReport?.generateOrder?.tongtienphong}
                        suffix="₫"
                        valueStyle={{ color: '#FF0000', fontSize: '18px' }}
                    />
                </Card.Grid>
                <Card.Grid style={gridStyle}>
                    <Statistic
                        title="Tiền dịch vụ"
                        value={dataReport?.generateOrder?.tongtiendichvu}
                        suffix="₫"
                        valueStyle={{ color: '#3f8600' }}
                    />
                </Card.Grid>
                <Card.Grid style={gridStyle}>
                    <Statistic
                        title="Tiền phòng thực thu"
                        value={dataReport?.generateOrder?.tongtien}
                        suffix="₫"
                        valueStyle={{ color: '#B10DC9' }}
                    />
                </Card.Grid>
                <Card.Grid style={gridStyle}>
                    {' '}
                    <Statistic
                        title="Tiền Thu"
                        value={dataReport?.thuchi?.tongThu}
                        suffix="₫"
                        valueStyle={{ color: '#FFDC00' }}
                    />
                </Card.Grid>
                <Card.Grid style={gridStyle}>
                    {' '}
                    <Statistic
                        title="Tiền Chi"
                        value={dataReport?.thuchi?.tongChi}
                        suffix="₫"
                        valueStyle={{ color: '#0000FF' }}
                    />
                </Card.Grid>
                <Card.Grid style={gridStyle}>
                    {' '}
                    <Statistic
                        title="Lược thuê"
                        value={dataReport?.generateOrder?.luotcheckin}
                        suffix="Lượt"
                        valueStyle={{ color: '#01FF70' }}
                    />
                </Card.Grid>
                {/* <Card.Grid style={gridStyle}>
                    <Statistic
                        title="Đã trả phòng"
                        value={dataReport?.generateOrder?.datraphong}
                        suffix="Lượt"
                        valueStyle={{ color: '#FFDC00' }}
                    />
                </Card.Grid>
                <Card.Grid style={gridStyle}>
                    <Statistic
                        title="Đang thuê"
                        value={dataReport?.generateOrder?.dangthue}
                        suffix="Lượt"
                        valueStyle={{ color: '#FF851B' }}
                    />
                </Card.Grid> */}
                {/* <Card.Grid style={gridStyle}>
                    <Statistic
                        title="Phòng dọn dẹp"
                        value={dataReport?.generateOrder?.dondep}
                        valueStyle={{ color: '#01FF70' }}
                    />
                </Card.Grid> */}
            </Card>
        </div>
    );
};

export default ReportStatus;
